import {
  autorun,
  makeAutoObservable,
  observable,
  runInAction,
  reaction
} from "mobx";
import GridStore from "./grid/grid.js";
import MultiSelectStore from "./MultiSelectStore.js";
import MultiSelectTextBox from "./MultiSelectTextBox.js";
import SocketStore from "./sockets/socketStore.js";
import { commonAxios, formDataAxios } from "../CommonAxios.js";
import ToggleStore from "./filterStore/toggleStore.js";
import RangeStore from "./filterStore/sliderStore.js";
import MinMaxStore from "./filterStore/minmaxStore.js";
import AndOrSelectDropdownStore from "./filterStore/andOrselectDropdownStore.js";
import filterStore from "./filterStore/dropdownStore.js";
import OffcanvaTableStore from "./filterStore/offcanvatableStore.js";
import axios from "axios";
import TaskStore from "./filterStore/taskStore"; // Import your MobX store
import { FieldMapperStore } from "./enrichmentStore/fieldMapperStore.js";
import { AISuggestionsStore } from "./enrichmentStore/aiSuggestionsStore.js";
import { LogicBuilderStore } from "./enrichmentStore/logicBuilderStore.js";
import SettingsStore from "../store/filterStore/settingsStore.js";
import { v4 as uuidv4 } from "uuid";
import { PhoneEmailSupperationStore } from "../store/enrichmentStore/phoneEmailSupperationStore.js";
import { showAlertToast } from "../../../Components/ToastComponent/AlertMessage.js";
import DashboardStore from "../../DynamicDashboard/DashboardStore.js";
import ManageUserStore from "../../ManageUsersExperian/ManageUsersStore.js";
import SubscriptionConfigStore from "../../SubscriptionConfig/SubscriptionConfigStore.js";
import PaymentHistyoryStore from "../../PaymentHistyory/PaymentHistyoryStore.js";
import TopNavBarStore from "../../../Components/NavBar/TopNavBarStore.js";
import CRMStore from "./CRMintegrationsStote/CRMStore.js";
import CreditConfigurationStore from "../../CreditConfiguration/CreditConfigurationStore.js";
import DynamicTableStore from "../../../Components/DynamicDashboardTable/DynamicTableStore.js";
import SubScriptionPageStore from "../../SubscriptionPage/SubScriptionPageStore.js";
import PaymentStatusStore from "../../PaymentStatus/PaymentStatusStore.js";
import ExportStore from "../store/enrichmentStore/ExportStore.js";
import MatchAppendStore from "../../MatchandAppend/MatchAppendStore/rootStore.js";
import AiChatBotStore from "../store/filterStore/aiChatBotStore.js"
class RootStore {
  fillterList = [];
  currentSearchtype = 'search'
  globalUserName = "";
  globalUserEmail = "";
  globalUserRole = "";
  globalUserCredits = 0;
  globalShowCredit = false;
  setUserRole = "";
  globalPermissions = [];
  globalAllowedRoutes = [];
  globalPermissionsLoaded = false;
  tableTitle = "";
  isEditing = false;
  socketStore;
  selectStores = new Map();
  selectTextStores = new Map();
  commonStore = new Map();
  toggleStore = new Map();
  rangeStores = new Map();
  minmaxStores = new Map();
  andOrselectDropdownStores = new Map();
  columnFilter = new Map();
  taskStore;
  savedSearchPayload = {};
  selectedFilters = new Set();
  tableReset = false;
  allowCellEdit = false;
  dynamicFlags = observable.map();
  taskList = [];
  savedSearchList = [];
  signUpStats = {
    paidSignup: 0,
    freeSignup: 0,
    totalSignup: 0,
  };
  searchapicalling = false;
  customerCreditUsageStats = {
    usedCredits: 0,
    purchaseCredits: 0,
    saveSearches: 0,
  };
  superAdminCalendar = {
    startRange: new Date(
      new Date().setDate(new Date().getDate() - 7)
    ).toLocaleDateString("en-CA"),
    endRange: new Date().toLocaleDateString("en-CA"),
  };
  isDropdownOpenSearch = [];
  menuConfiguration = [];
  listOfAllFields = [];
  sentenceArray = [
    "Find 10 Tech Companies in Somerset",
    "Search for the top AI startups in Berlin",
    "Get a list of SaaS companies in San Francisco",
    "Find cybersecurity firms in London",
    "Look up renewable energy companies in Canada",
  ];
  commonRootStoreMap = new Map([
    ["selectedButton", null],
    ["popupItem", null],
    ["activeTab", null],
    ["showModalEnrichment", false],
    ["modalOpen", false],
    ["savedSearchName", null],
    ["selectedSearchId", null],
    ["tempsavedoldName", ""],
    ["basicFields", []],
    ["advancedFileds", []],
    ["selectEnrichmentPopup", false],
    ["searchMenuOpen", false],
    ["uploadModalOpen", false],
    ["contentDataCSV", []],
    ["fileNames", ""],
    ["fieldName", "defaultField"],
    ["fileuploaderror", ""],
    ["loadingUploadCSV", false],
    ["progressMovedRecords", 0],
    ["selectedEmails", []],
    ["inputEmail", ""],
    ["shareModalIsOpen", false],
    ["showSendbutton", true],
    ["fileimportloader", false],
    ["contentSource", ""],
    ["invalidMailflag", ""],
    ["serachPrompt", ""],
    ["idFromSavedSeatch", ""],
    ["CommonLoader", false],
    ["tableLoader", false],
    ["crmModalOpen", false],
    ["suggestions", []],
    ["showSuggestions", false],
    ["noOfContacts", ""],
    ["apiFlag", false],
  ]);
  constructor() {
    this.gridStore = new GridStore(this);
    this.multiSelectStore = new MultiSelectStore(this);
    this.socketStore = new SocketStore(this);
    this.commonAxios = commonAxios;
    this.formDataAxios = formDataAxios;
    this.dynamicFlags.set("resetAllActive", false);
    this.dynamicFlags.set("csvFile", null);
    this.filterStore = new filterStore(this);
    this.formDataAxios = formDataAxios;
    this.taskStore = new TaskStore(this);
    this.OffcanvaTableStore = new OffcanvaTableStore(this);
    this.settingsStore = new SettingsStore(this);
    makeAutoObservable(this);
    this.fieldMapperStore = new FieldMapperStore(this);
    this.aiSuggestionsStore = new AISuggestionsStore(this);
    this.logicBuilderStore = new LogicBuilderStore(this);
    this.phoneEmailSupperationStore = new PhoneEmailSupperationStore(this);
    this.crmStore = new CRMStore(this);
    this.dashboardStore = new DashboardStore(this);
    this.manageUserStore = new ManageUserStore(this);
    this.subscriptionConfigStore = new SubscriptionConfigStore(this);
    this.PaymentHistyoryStore = new PaymentHistyoryStore(this);
    this.TopNavBarStore = new TopNavBarStore(this);
    this.CreditConfigurationStore = new CreditConfigurationStore(this);
    this.DynamicTableStore = new DynamicTableStore(this);
    this.SubScriptionPageStore = new SubScriptionPageStore(this);
    this.PaymentStatusStore = new PaymentStatusStore(this);
    this.ExportStore = new ExportStore(this);
    this.matchAppendStore = new MatchAppendStore(this);
    this.aiChatBotStore = new AiChatBotStore(this);
    autorun(() => { });
    reaction(
      () => this.gridStore.tabIndex,
      (value) => {
        if (value === 2) {
          this.getSavedSearchList();
        } else {
          this.gridStore.defaultAPIcall = true;
        }
      }
    );
    reaction(
      () => [
        this.gridStore.tableCompanyId,
        this.gridStore.tablePeopleId,
      ],
      async () => {
        const { tableCompanyId, tablePeopleId } = this.gridStore;
        if (tableCompanyId && (this.socketStore.socketInitialized.company === false || this.socketStore.socketTableIds.company !== tableCompanyId)) {
          this.socketStore.initializeSocket("company", tableCompanyId);
        }
        if (tablePeopleId && (this.socketStore.socketInitialized.people === false || this.socketStore.socketTableIds.people !== tablePeopleId)) {
          this.socketStore.initializeSocket("people", tablePeopleId);
        }
        if (this.gridStore.tableCompanyId && this.gridStore.tablePeopleId) {
          runInAction(() => {
            this.resetAllActivefun();
          });
        }
      },
      {
        equals: (a, b) => false // Always trigger the reaction, even if values are the same
      }
    );
  }
  handleSearchtype(type) {
    runInAction(() => {
      this.currentSearchtype = type;
    })
  }
  formatDate(date) {
    return date.toISOString().split("T")[0]; // "YYYY-MM-DD"
  }
  setDefaultDateRange() {
    const today = new Date();
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(today.getDate() - 6);
    this.superAdminCalendar = {
      startRange: this.formatDate(sevenDaysAgo),
      endRange: this.formatDate(today),
    };
  }
  // You can also add a method to manually update the calendar
  setCustomDateRange(start, end) {
    this.superAdminCalendar = {
      startRange: this.formatDate(new Date(start)),
      endRange: this.formatDate(new Date(end)),
    };
  }
  setSuperAdminCalendar = (value) => {
    this.superAdminCalendar = value;
  };
  get getselectedButton() {
    return this.commonRootStoreMap.get("selectedButton");
  }
  // get getshowModal() {
  //   return this.commonRootStoreMap.get("showModal");
  // }
  get getpopupItem() {
    return this.commonRootStoreMap.get("popupItem");
  }
  get getactiveTab() {
    return this.commonRootStoreMap.get("activeTab");
  }
  get getshowModalEnrichment() {
    return this.commonRootStoreMap.get("showModalEnrichment");
  }
  get getmodalOpen() {
    return this.commonRootStoreMap.get("modalOpen");
  }
  get getCrmModalOpen() {
    return this.commonRootStoreMap.get("crmModalOpen");
  }
  get getsavedSearchName() {
    return this.commonRootStoreMap.get("savedSearchName");
  }
  get gettempsavedoldName() {
    return this.commonRootStoreMap.get("tempsavedoldName");
  }
  get getselectedSearchId() {
    return this.commonRootStoreMap.get("selectedSearchId");
  }
  get getbasicFields() {
    return this.commonRootStoreMap.get("basicFields") || [];
  }
  get getadvancedFields() {
    return this.commonRootStoreMap.get("advancedFileds") || [];
  }
  get getSelectEnrichmentPopup() {
    return this.commonRootStoreMap.get("selectEnrichmentPopup");
  }
  get getSearchMenuOpen() {
    return this.commonRootStoreMap.get("searchMenuOpen");
  }
  get getUploadModalOpen() {
    return this.commonRootStoreMap.get("uploadModalOpen");
  }
  get getContentData() {
    return this.commonRootStoreMap.get("contentDataCSV");
  }
  get getFileNames() {
    return this.commonRootStoreMap.get("fileNames");
  }
  get getFieldName() {
    return this.commonRootStoreMap.get("fieldName");
  }
  get getProgressMovedRecords() {
    return this.commonRootStoreMap.get("progressMovedRecords");
  }
  get getShareModalIsOpen() {
    return this.commonRootStoreMap.get("shareModalIsOpen");
  }
  get getSelectedEmail() {
    return this.commonRootStoreMap.get("selectedEmails");
  }
  get getSignupStats() {
    return this.signUpStats;
  }
  get getInputEmail() {
    return this.commonRootStoreMap.get("inputEmail");
  }
  get getShowSendbutton() {
    return this.commonRootStoreMap.get("showSendbutton");
  }
  get getLoaderUploadCSV() {
    return this.commonRootStoreMap.get("loadingUploadCSV");
  }
  get getSuggesstions() {
    return this.commonRootStoreMap.get("suggestions");
  }
  get getShowSuggesstions() {
    return this.commonRootStoreMap.get("showSuggestions");
  }
  get getNoOfContacts() {
    return this.commonRootStoreMap.get("noOfContacts");
  }
  get getApiFlag() {
    return this.commonRootStoreMap.get("apiFlag");
  }
  get getPermission() {
    let defaultPermission = {
      deleteColumn: false,
      renameTable: false,
      addColumn: false,
      renameColumn: false,
      share: true,
    };
    let dynamicPermission = this.commonRootStoreMap.get("permission");
    if (dynamicPermission) {
      defaultPermission.deleteColumn = dynamicPermission.deleteColumn;
      defaultPermission.renameTable = dynamicPermission.renameTable;
      defaultPermission.addColumn = dynamicPermission.addColumn;
      defaultPermission.renameColumn = dynamicPermission.renameColumn;
      defaultPermission.share = dynamicPermission.share;
    }
    return defaultPermission;
  }
  get isSendDisabled() {
    return this.getSelectedEmail.some(
      (email) =>
        !email.startRange ||
        !email.endRange ||
        Number(email.endRange) < Number(email.startRange) ||
        Number(email.startRange) > this.gridStore.totalRecode ||
        Number(email.endRange) > this.gridStore.totalRecode
    );
  }
  get ShowErrorMessage() {
    return this.getSelectedEmail.some(
      (email) =>
        Number(email.endRange) < Number(email.startRange) ||
        Number(email.startRange) > this.gridStore.totalRecode ||
        Number(email.endRange) > this.gridStore.totalRecode
    );
  }
  applyTheValue(updates) {
    runInAction(() => {
      for (const [key, value] of Object.entries(updates)) {
        this.commonRootStoreMap.set(key, value);
      }
    });
  }
  callCommonLoader(state) {
    runInAction(() => {
      this.applyTheValue({
        CommonLoader: state,
      });
    });
  }
  setserachPrompt = (value) => {
    runInAction(() => {
      this.applyTheValue({ serachPrompt: value });
    });
  };
  openUploadModal = () => {
    this.applyTheValue({ uploadModalOpen: true });
  };

  handleAIJobTitle = async (jobTitle) => {
    console.log(jobTitle, this.multiSelectStore.inputValueAI, "jobTitle");

    try {
      // const response = await commonAxios("/getjob", "POST", {},
      //   {
      //     jobTitle: jobTitle,
      //   }
      // );

      this.multiSelectStore.setInputValueAI("");
      // return response;
    } catch (e) {
      console.log(e, "error");
    }
  };

  closeUploadModal = () => {
    this.applyTheValue({
      uploadModalOpen: false,
      contentSource: "manual",
    });
  };
  get enableFillterToggle() {
    return (
      this.gridStore.totalRecode === this.gridStore.rows.size &&
      this.gridStore.totalRecode <= 50000
    );
  }

  handleFileChange = async (event, fieldName) => {
    const file = event.target.files[0];
    if (!file) return;
    this.applyTheValue({
      fileNames: file.name,
      contentSource: "file",
      fileimportloader: true,
      contentDataCSV: [],
    });
    if (file.size > 5000) {
      this.applyTheValue({
        fileuploaderror: "File Size exceeded the limit 5K",
        fileimportloader: false,
      });
      return;
    }
    this.applyTheValue({ fileuploaderror: "" });
    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const content = e.target.result;
        const rows = content
          .split("\n")
          .map((row) =>
            row
              .replace(/\t/g, ",")
              .split(/,(?=(?:[^"]*"[^"]*")*[^"]*$)/)
              .map((cell) =>
                cell.replace(/\r/, "").replace(/^"|"$/g, "").trim()
              )
          )
          .filter((row) => row.length > 0);
        const dataRows = rows.slice(1);
        const keyValueData = dataRows.flatMap((row) =>
          row.map((value) => ({
            value,
            label: value,
          }))
        );
        this.applyTheValue({
          contentDataCSV: keyValueData,
        });
      } catch (error) {
        this.applyTheValue({
          fileuploaderror: error.message,
        });
      } finally {
        this.applyTheValue({ fileimportloader: false });
      }
    };
    event.target.value = null;
    reader.readAsText(file);
  };
  // Import CSV logic
  handleImportCSV = async () => {
    const content = JSON.parse(JSON.stringify(this.getContentData));
    const key = this.getSearchMenuOpen;
    this.applyTheValue({ fileimportloader: true });
    const store =
      this.selectStores.get(key.id) ?? this.selectTextStores.get(key.id);
    await store.restoreSelectedValues(content);
    runInAction(() => {
      this.closeUploadModal();
      this.applyTheValue({
        searchMenuOpen: null,
        contentDataCSV: [],
        fileNames: "",
        fileimportloader: false,
      });
    });
  };
  handleClearImportdata = () => {
    const key = this.getSearchMenuOpen;
    const store =
      this.selectStores.get(key.id) ?? this.selectTextStores.get(key.id);
    store.handleClearAll();
    this.applyTheValue({ searchMenuOpen: null });
  };
  handleExportData = () => {
    const keys = this.getSearchMenuOpen;
    const store = this.selectStores.get(keys.id);
    const content = JSON.parse(JSON.stringify(store.selectedValues));
    const plainText = content.map((item) => item.label).join("\n");
    const targetKey = keys?.id?.toLowerCase() || "all";
    // Create a text blob and export it
    const blob = new Blob([plainText], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${targetKey}_titles.txt`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    this.applyTheValue({ searchMenuOpen: null });
  };
  setSelectedSearchId = (id) => {
    this.selectedSearchId = id;
  };
  setSearchName(name) {
    this.searchName = name;
  }
  resetModal() {
    this.modalOpen = false;
    this.searchName = "";
  }
  toggleModal() {
    this.showModalEnrichment = !this.showModalEnrichment;
  }
  closeModalEnrichment = () => {
    this.showModalEnrichment = false;
  };
  setUnKnownFlag(key, value) {
    runInAction(() => {
      this.dynamicFlags.set(key, value);
    });
  }
  getUnKnownFlag(key) {
    return this.dynamicFlags.get(key);
  }
  getMultiSelectStoreLength(obj) {
    let isSelectStores = this.selectStores.has(obj.keyname);
    let isSelectTextStores = this.selectTextStores.has(obj.keyname);
    let returnResult = false;
    if (isSelectStores) {
      let store = this.selectStores.get(obj.keyname);
      if (store.selectedValues.length >= obj.length) {
        returnResult = true;
      }
    }
    if (isSelectTextStores) {
      let store = this.selectTextStores.get(obj.keyname);
      if (store.selectedValues.length >= obj.length) {
        returnResult = true;
      }
    }
    return returnResult;
  }
  setModalItem = (item) => {
    runInAction(() => {
      this.applyTheValue({ popupItem: item });
      this.applyTheValue({ searchMenuOpen: null });
    });
  };
  setSearchMenu = (item) => {
    this.applyTheValue({ searchMenuOpen: item });
  };
  openEditor = () => {
    this.tempText = this.text;
    this.isEditing = true;
  };
  closeEditor = () => {
    this.isEditing = false;
  };
  setAnchorEl = (el) => {
    this.anchorEl = el;
    this.isMenuOpen = true;
  };
  getCustomerCreditUsageStats = (field, value) => {
    this.customerCreditUsageStats[field] = value;
  };
  setCustomer = (field, value) => {
    this.signUpStats[field] = value;
  };
  closeMenu = () => {
    this.anchorEl = null;
    this.isMenuOpen = false;
  };
  handleCheckboxChange = (filter) => {
    if (this.selectedFilters.has(filter)) {
      this.selectedFilters.delete(filter);
    } else {
      this.selectedFilters.add(filter);
    }
  };

  saveAndFetch = async () => {
    try {
      this.saveText(this.tempText);
      await this.fetchTableName(); // Uses userId and tableId from gridStore
    } catch (error) {
      console.error(error);
    }
  };

  setSelectedButton(button) {
    if (this.selectedButton === button) {
      // If the same button is clicked again, deselect it
      this.selectedButton = null;
    } else {
      // Otherwise, set the new selected button
      this.selectedButton = button;
    }
  }
  setTableTitle(value) {
    runInAction(() => {
      this.tableTitle = value;
    });
  }
  clearAll() {
    runInAction(() => {
      this.selectStores.forEach((store) => {
        if (store?.clearMe) {
          store.clearMe();
        }
      });
      this.selectTextStores.forEach((store) => {
        if (store?.clearMe) {
          store.clearMe();
        }
      });
      this.toggleStore.forEach((store) => {
        if (store?.clearMe) {
          store.clearMe();
        }
      });
      this.rangeStores.forEach((store) => {
        if (store?.clearMe) {
          store.clearMe();
        }
      });
      this.minmaxStores.forEach((store) => {
        if (store?.clearMe) {
          store.clearMe();
        }
      });
      this.andOrselectDropdownStores.forEach((store) => {
        if (store?.clearMe) {
          store.clearMe();
        }
      });
      this.gridStore.totalRecode = 0;
    });
    showAlertToast({
      type: "success", // probably 'error' for a validation fail
      title: "Successfully Cleared",
      message: "All filters are cleared successfully.",
    });
  }
  extractRoutes = (data) => {
    const routes = [];
    const excludedRoutes = []; // Routes to exclude
    function traverse(items) {
      items.forEach((item) => {
        if (item.path) {
          // Skip excluded paths
          routes.push(item.path);
        }
        if (item.children) {
          traverse(item.children); // Recursively check children
        }
        if (item.basePathList && item.basePathList.length > 0) {
          routes.push(...item.basePathList);
        }
      });
    }
    traverse(data);
    return [...new Set(routes)]; // Remove duplicates (if any)
  };
  handleSideNavBar = async () => {
    try {
      const response = await commonAxios("/fetchNavBar", "POST", {}, {});
      this.extractRoutes(response?.data);
      return response;
    } catch (e) {
      console.error(error);
    }
  };
  handleGlobalRoutes = async () => {
    try {
      const response = await commonAxios("/fetchNavBar", "POST", {}, {});
      if (response?.data) {
        const jsonData = response?.data;
        const formattedData = jsonData
          .filter((element) => element.type === "dropdown")
          .map((item) => {
            return {
              [item.title]: false,
            };
          })
          .reduce((acc, obj) => ({ ...acc, ...obj }), {});
        const allowedRoutes = this.extractRoutes(response?.data);
        runInAction(() => {
          this.setGlobalAllowedRoutes(allowedRoutes);
          this.setIsDropdownOpenSearch(formattedData);
          this.setMenuConfiguration(jsonData);
        });
      }
      return response;
    } catch (e) {
      console.error(e);
    } finally {
      runInAction(() => {
        this.globalPermissionsLoaded = true;
      });
    }
  };
  handleSignupStats = async () => {
    try {
      const response = await commonAxios(
        "/signupInfo",
        "POST",
        {},
        {
          startDate: this.superAdminCalendar.startRange,
          endDate: this.superAdminCalendar.endRange,
        }
      );
      if (response?.data) {
        runInAction(() => {
          this.signUpStats.paidSignup = response?.data?.paidUsers;
          this.signUpStats.freeSignup = response?.data?.freeUsers;
          this.signUpStats.totalSignup = response?.data?.overAll;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  handleLoginInfo = async () => {
    try {
      const response = await commonAxios(
        "/lastLoginInfo",
        "POST",
        {},
        {
          startDate: this.superAdminCalendar.startRange,
          endDate: this.superAdminCalendar.endRange,
        }
      );
      return response;
    } catch (e) {
      console.error(e);
    }
  };
  handleCustomerCreditUsageStats = async () => {
    try {
      const response = await commonAxios(
        "/dashBoardStats",
        "POST",
        {},
        {
          startDate: this.superAdminCalendar.startRange,
          endDate: this.superAdminCalendar.endRange,
        }
      );
      if (response?.data) {
        runInAction(() => {
          this.customerCreditUsageStats.usedCredits =
            response?.data?.usedCredits;
          this.customerCreditUsageStats.purchaseCredits =
            response?.data?.purchaseCredits;
          this.customerCreditUsageStats.saveSearches =
            response?.data?.saveSearches;
        });
      }
    } catch (e) {
      console.error(e);
    }
  };
  savedSearch = async () => {
    const formattedData = {};
    // Directly populate from selectStores
    this.selectStores.forEach((store, key) => {
      formattedData[key] = {
        selectAllEnabled: store.selectAllEnabled,
        customOptions: store.customOptions,
        selectAllIgnored: store.selectAllIgnored,
        selectedValues: store.selectedValues,
      };
    });
    this.selectTextStores.forEach((store, key) => {
      formattedData[key] = {
        customOptions: store.customOptions,
        selectedValues: store.selectedValues,
      };
    });
    this.toggleStore.forEach((store, key) => {
      formattedData[key] = store.value;
    });
    this.rangeStores.forEach((store, key) => {
      formattedData[key] = {
        minValue: store.min,
        maxValue: store.max,
        startRange: store.start,
        endRange: store.end,
      };
    });
    this.minmaxStores.forEach((store, key) => {
      formattedData[key] = {
        minStartRange: "" + store.minStartRange,
        minEndRange: "" + store.minEndRange,
        maxStartRange: "" + store.maxStartRange,
        maxEndRange: "" + store.maxEndRange,
        minValue: "" + store.start,
        maxValue: "" + store.end,
      };
    });
    this.andOrselectDropdownStores.forEach((store, key) => {
      formattedData[key] = {
        selectedValues: store.selectedValues,
        operatorSelectedValues: store.operator,
      };
    });
    const res = await commonAxios(
      "/saveSavedSearch",
      "POST",
      {},
      {
        data: formattedData,
        title: this.getsavedSearchName,
        searchId:
          this.getsavedSearchName === this.gettempsavedoldName
            ? this.getselectedSearchId
            : null,
        type: this.gridStore.tabIndex === 0 ? "company" : "people",
      }
    );
    if (res) {
      if (res?.data?.searchId ?? "");
      {
        this.setSelectedSearchId(res?.data?.id);
      }
      showAlertToast({
        type: "success", // probably 'error' for a validation fail
        title: "successfully saved",
        message: "Your searches are saved successfully.",
      });
    }
  };
  getSavedSearchList = async () => {
    try {
      const res = await commonAxios(`/listSavedSearch`, "GET");
      const response = res?.data?.list ?? [];
      runInAction(() => {
        this.savedSearchList = response;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => {
        this.savedSearchList = [];
      });
    }
  };
  getAllSelectedValues() {
    const allSelectedValues = new Map();
    const formatArray = (arr) =>
      Array.isArray(arr) ? arr.map((item) => item.value).join(",") : arr;
    const addToMap = (key, type, value) => {
      allSelectedValues.set(key, {
        key,
        type,
        value,
      });
    };
    // Process selectStores
    this.selectStores.forEach((store, key) => {
      addToMap(key, "multiselect", {
        selectAllEnabled: store.selectAllEnabled,
        customOptions: formatArray(store.customOptions),
        selectAllIgnored: formatArray(store.selectAllIgnored),
        selectedValues: formatArray(
          store.selectedValues.filter(
            (item) => item.label !== "Select All" && item.value !== "all"
          )
        ),
      });
    });
    // Process selectTextStores
    this.selectTextStores.forEach((store, key) => {
      addToMap(key, "text", {
        customOptions: formatArray(store.customOptions),
        selectedValues: formatArray(store.selectedValues),
      });
    });
    // Process toggleStore
    this.toggleStore.forEach((store, key) => {
      addToMap(key, "toggle", store?.value ?? false);
    });
    // Process rangeStores
    this.rangeStores.forEach((store, key) => {
      addToMap(key, "range", {
        minValue: store.min,
        maxValue: store.max,
        startRange: store.start,
        endRange: store.end,
      });
    });
    this.minmaxStores.forEach((store, key) => {
      addToMap(key, "minmax", {
        minStartRange: "" + store.minStartRange,
        minEndRange: "" + store.minEndRange,
        maxStartRange: "" + store.maxStartRange,
        maxEndRange: "" + store.maxEndRange,
        minValue: "" + store.start,
        maxValue: "" + store.end,
      });
    });
    this.andOrselectDropdownStores.forEach((store, key) => {
      addToMap(key, "dropdown", {
        keys: formatArray(store.selectedValues),
        operator: formatArray(store.operator),
      });
    });
    return allSelectedValues;
  }
  hasValidPayload(payloadArray) {
    return payloadArray.some(({ type, value }) =>
      (["multiselect", "text"].includes(type) && value?.selectedValues?.length > 0) ||
      (type === "toggle" && value === true) ||
      (type === "minmax" && (value?.maxValue !== "null" || value?.minValue !== "null")) ||
      (type === "range" && value && (
        (value.startRange != null && value.startRange !== value.minValue) ||
        (value.endRange != null && value.endRange !== value.maxValue)
      )) ||
      (type === "dropdown" && value?.keys?.length > 0)
    );
  }

  generateCompanyApi = async ({
    triggerKey = "",
    helpMe = false,
    spacialFlag = false,
    spacialFlagforPeople = false,
  }) => {
    if (this.searchapicalling) {
      return
    }
    runInAction(() => {
      this.searchapicalling = true
    })
    try {
      const columnNames = Array.from(this.gridStore.columns.keys())
        .filter((col) => col !== "SNO")
        .map((col) => col)
        .join(",");
      const payloadMap = this.getAllSelectedValues();
      const payloadArray = Array.from(payloadMap.values());
      if (!this.hasValidPayload(payloadArray)) {
        showAlertToast({
          type: "warning", // probably 'error' for a validation fail
          title: "Note",
          message: "Please select at least one filter before searching.",
        });
        return;
      }
      const formatArray = (arr) =>
        Array.isArray(arr) ? arr.map((item) => item.label).join(",") : arr;
      // const formattedData = {};
      // Directly populate from selectStores
      if(this.gridStore.offset === 0) {
        this.selectStores.forEach((store, key) => {
          this.savedSearchPayload[key] = {
            selectAllEnabled: store.selectAllEnabled,
            customOptions: store.customOptions,
            selectAllIgnored: store.selectAllIgnored,
            selectedValues: store.selectedValues,
          };
        });
        this.selectTextStores.forEach((store, key) => {
          this.savedSearchPayload[key] = {
            customOptions: store.customOptions,
            selectedValues: store.selectedValues,
          };
        });
        this.toggleStore.forEach((store, key) => {
          this.savedSearchPayload[key] = store.value;
        });
        this.rangeStores.forEach((store, key) => {
          this.savedSearchPayload[key] = {
            minValue: store.min,
            maxValue: store.max,
            startRange: store.start,
            endRange: store.end,
          };
        });
        this.minmaxStores.forEach((store, key) => {
          this.savedSearchPayload[key] = {
            minStartRange: "" + store.minStartRange,
            minEndRange: "" + store.minEndRange,
            maxStartRange: "" + store.maxStartRange,
            maxEndRange: "" + store.maxEndRange,
            minValue: "" + store.start,
            maxValue: "" + store.end,
          };
        });
        this.andOrselectDropdownStores.forEach((store, key) => {
          this.savedSearchPayload[key] = {
            selectedValues: store.selectedValues,
            operatorSelectedValues: store.operator,
          };
        });
      }
      try {
        const res = await commonAxios(
          "/search",
          "POST",
          {},
          {
            payload: payloadArray,
            tableId:
              this.gridStore.tabIndex === 0
                ? this.gridStore.tableCompanyId
                : this.gridStore.tablePeopleId,
            userId: this.gridStore.userId,
            triggerKey: triggerKey,
            helpMe: helpMe,
            fillterKey: formatArray(this.filterStore.selectedFilters),
            type: this.gridStore.tabIndex === 0 ? "company" : "people",
            limit: this.gridStore.limit < this.gridStore.totaRecordPerPage
              ? this.gridStore.totaRecordPerPage
              : this.gridStore.limit,
            offset:
              this.gridStore.offset === 0 ? 0 : this.gridStore.visibleRows.length,
            columnName: columnNames,
          }
        );

        if (res) {
          runInAction(() => {
            this.gridStore.offsetValue = this.gridStore.visibleRows.length;
            this.gridStore.offset += this.gridStore.limit;
            this.gridStore.freshTableNew = false;
            this.applyTheValue({ apiFlag: false })
            if (spacialFlag) {
              this.gridStore.searchCompanyInfoModal = false;
              localStorage.setItem("searchCompanyInfo", JSON.stringify(false));
            }
            if (spacialFlagforPeople) {
              this.gridStore.searchPeopleInfoModal = false;
              localStorage.setItem("searchPeopleInfo", JSON.stringify(false));
            }
          });

          // ✅ After setting flags, append and increase offset
          const newRows = res?.data?.items || [];
        }
      } catch (error) {
        console.error(error);
        runInAction(() => {
          this.gridStore.isFetching = false; // reset even on failure
        });
      } finally {
        runInAction(() => {
          this.gridStore.isFetching = false; // ✅ Ensure it resets no matter what
        });
      }
    } catch (error) {
      console.log("Error in generateCompanyApi:", error);
    } finally {
      runInAction(() => {
        this.searchapicalling = false
      })
    }
  };
  taskListApi = async () => {
    try {
      const response = await commonAxios(
        "/getEnrichProgressList",
        "POST",
        {},
        {
          tableId:
            this.gridStore.tabIndex === 0
              ? this.gridStore.tableCompanyId
              : this.gridStore.tablePeopleId,
          userId: this.gridStore.userId,
          status: this.gridStore.tabIndex === 0 ? "pending" : "completed",
        }
      );
      const list = response?.data?.list || [];
      runInAction(() => {
        this.taskList = list;
      });
    } catch (error) { 
      console.error(error);
    }
  };
  fetchList = async () => {
    try {
      const response = await commonAxios("/getSearchFields", "GET", {}, {});
      runInAction(() => {
        this.fillterList.replace(response?.data?.list || []);
      });
    } catch (error) { 
      console.error(error);
    }
  };
  async fetchTableName() {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_EXPERIAN_API}/experian/updateTableName`,
        {
          tableId:
            this.gridStore.tabIndex === 0
              ? this.gridStore.tableCompanyId
              : this.gridStore.tablePeopleId,
          userId: this.gridStore.userId,
          tableName: this.text,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
    } catch (error) { 
      console.error(error);
    }
  }
  async getUserIdFromEmail(email) {
    try {
      this.applyTheValue({ invalidMailflag: "" });
      const res = await commonAxios("/getUserId", "POST", {}, { email: email });
      const userData = res?.data?.info?.data[0];
      if (userData) {
        const { emailAddress, userId } = userData;
        const currentSelected = this.getSelectedEmail || [];
        // Prevent duplicates
        const alreadyExists = currentSelected.some(
          (item) => item.email === emailAddress
        );
        if (alreadyExists) {
          this.applyTheValue({
            invalidMailflag: "User already exists in list",
          });
        }
        if (!alreadyExists) {
          const updated = [
            ...currentSelected,
            {
              email: emailAddress,
              userId: userId,
            },
          ];
          this.applyTheValue({ selectedEmails: updated });
        }
      }
    } catch (error) {
      runInAction(() => {
        const msg = error?.response?.data?.error?.message;
        this.applyTheValue({ invalidMailflag: msg });
      });
    }
  }
  getSharedUserId = async () => {
    try {
      const res = await commonAxios(
        `/listAccessUsers?tableId=${this.gridStore.tabIndex === 0
          ? this.gridStore.tableCompanyId
          : this.gridStore.tablePeopleId
        }`,
        "GET"
      );
      this.applyTheValue({ selectedEmails: res?.data?.accessUsers ?? [] });
    } catch (error) {
      console.error(error);
     }
  };
  async shareEmailApi() {
    try {
      const res = await commonAxios(
        "/saveAccessUsers",
        "POST",
        {},
        {
          tableId:
            this.gridStore.tabIndex === 0
              ? this.gridStore.tableCompanyId
              : this.gridStore.tablePeopleId,
          userId: this.gridStore.userId,
          accessUsers: this.getSelectedEmail,
        }
      );
      if (res) {
        this.applyTheValue({ shareModalIsOpen: false });
      }
    } catch (error) {
      console.error(error);
     }
  }
  getSelectStore(fieldKey) {
    if (!this.selectStores.has(fieldKey)) {
      this.selectStores.set(fieldKey, new MultiSelectStore(this, fieldKey));
    }
    return this.selectStores.get(fieldKey);
  }
  getToggleStore(fieldKey) {
    if (!this.toggleStore.has(fieldKey)) {
      this.toggleStore.set(fieldKey, new ToggleStore(this, fieldKey));
    }
    return this.toggleStore.get(fieldKey);
  }
  getRangeStore(fieldKey) {
    if (!this.rangeStores.has(fieldKey)) {
      this.rangeStores.set(fieldKey, new RangeStore(this, fieldKey));
    }
    return this.rangeStores.get(fieldKey);
  }
  getminmaxStore(fieldKey) {
    if (!this.minmaxStores.has(fieldKey)) {
      this.minmaxStores.set(fieldKey, new MinMaxStore(this, fieldKey));
    }
    return this.minmaxStores.get(fieldKey);
  }
  getandOrselectDropdownStores(fieldKey) {
    if (!this.andOrselectDropdownStores.has(fieldKey)) {
      this.andOrselectDropdownStores.set(
        fieldKey,
        new AndOrSelectDropdownStore(this, fieldKey)
      );
    }
    return this.andOrselectDropdownStores.get(fieldKey);
  }
  getSelectTextStore(fieldKey) {
    if (!this.selectTextStores.has(fieldKey)) {
      this.selectTextStores.set(
        fieldKey,
        new MultiSelectTextBox(this, fieldKey)
      );
    }
    console.log(fieldKey, 'fieldKey');

    this.dynamicFlags.set(fieldKey, new MultiSelectStore(this, fieldKey));
    return this.selectTextStores.get(fieldKey);
  }

  getDynamicDropDown(fieldKey) {
    if (!this.dynamicFlags.has(fieldKey)) {
      this.dynamicFlags.set(fieldKey, new MultiSelectStore(this, fieldKey));
    }
    const store = this.dynamicFlags.get(fieldKey);
    return store;
  }
  deleteDynamicDropDown(fieldKey) {
    return this.dynamicFlags.delete(fieldKey);
  }
  getCommonFlag(fieldKey) {
    if (!this.commonStore.has(fieldKey)) {
      this.commonStore.set(fieldKey, null);
    }
    return this.commonStore.get(fieldKey);
  }
  setCommonFlag(fieldKey, value) {
    this.commonStore.set(fieldKey, value);
  }
  setEditablecell(value) {
    runInAction(() => {
      this.allowCellEdit = value;
    });
  }
  resetAllActivefun(state) {
    this.dynamicFlags.set("resetAllActive", state);
    this.gridStore.refreshTableSocketCall();
  }
  hierarchyUpdate = (keyname) => {
    runInAction(() => {
      keyname.refill.forEach(({ keyword, options }) => {
        if (this.selectStores.has(keyword)) {
          const store = this.selectStores.get(keyword);
          if (store?.clearMe) {
            store.clearMe();
          }
          store.setOptions(options);
          const selectedOptions = options.filter(item => item?.selected === true); // or just `item.selected`
          store.handleSelectChange({
            selected: selectedOptions,
            trigger: false,
          });
        }
        else if (this.selectTextStores.has(keyword)) {
          const store = this.selectTextStores.get(keyword);
          if (store?.clearMe) {
            store.clearMe();
          }
          store.setOptions(options);
          const selectedOptions = options.filter(item => item?.selected === true); // or just `item.selected`
          store.setSelectedValues({
            values: selectedOptions,
            trigger: false,
          });
        }
      });
    });
  }

  hierarchyUpdateAI = (keyname) => {
    console.log(keyname, "keyname");

    runInAction(() => {
      keyname.fill.forEach(({ keyword, options }) => {
        console.log(this.selectTextStores.has(keyword), "keyMatch");

        if (this.selectStores.has(keyword)) {
          const store = this.selectStores.get(keyword);
          if (store?.clearMe) {
            store.clearMe();
          }

          // ✅ Set full options first
          store.setOptions(options);

          // ✅ Now filter selected values and set them
          const selectedOptions = options.filter(item => item?.selected === true);
          store.handleSelectChange({
            selected: selectedOptions,
            trigger: false,
          });
        }
        else if (this.selectTextStores.has(keyword)) {
          const store = this.selectTextStores.get(keyword);
          if (store?.clearMe) {
            store.clearMe();
          }

          // ✅ Set full options
          store.setOptions(options);

          // ✅ Set selected values
          const selectedOptions = options.filter(item => item?.selected === true);
          store.setSelectedValues({
            values: selectedOptions,
            trigger: false,
          });
        }

      });
    });
  }

  getSavedSearchData = async (id) => {
    let res;
    const searchId = id.length > 0 ? id : this.getselectedSearchId
    runInAction(() => {
      this.clearAll();
    })
    try {
      res = await commonAxios(
        `/getSavedSearch?id=${searchId}`,
        "GET"
      );
      const response = res?.data?.data ?? {};
      runInAction(() => {
        if (this?.currentSearchtype === "search") {
          console.log("Got in tab changes getsaved")
          this.gridStore.tabIndex = res?.data?.data?.type === "company" ? 0 : 1;
        }
      })
      runInAction(() => {
        Object.entries(response.data).forEach(([key, value]) => {
          if (this.selectTextStores.has(key)) {
            const store = this.selectTextStores.get(key);
            store.restoreCustomOptions(value?.customOptions ?? []);
            store.setSelectedValues({ values: value?.selectedValues ?? [] });
          }
          else if (this.selectStores.has(key)) {
            const store = this.selectStores.get(key);
            runInAction(() => {
              store.restoreSelectedValues(value?.selectedValues ?? []);
              store.restoreSelectAllIgnored(value?.selectAllIgnored ?? false);
              store.restoreSelectAllEnabled(value?.selectAllEnabled ?? false);
              store.restoreCustomOptions(value?.customOptions ?? []);
            });
          } else if (this.toggleStore.has(key)) {
            const store = this.toggleStore.get(key);
            store.setValue({ val: value, trigger: false }); // assuming value is a primitive like boolean
          } else if (this.rangeStores.has(key)) {
            const store = this.rangeStores.get(key);
            store.setRange({
              start: value?.startRange ?? null,
              end: value?.endRange ?? null,
            });
          } else if (this.minmaxStores.has(key)) {
            const store = this.minmaxStores.get(key);
            store.setRange({ name: "start", value: value.minValue });
            store.setRange({ name: "end", value: value.maxValue });
          } else if (this.andOrselectDropdownStores.has(key)) {
            const store = this.andOrselectDropdownStores.get(key);
            store.setOperator(value.operatorSelectedValues);
            store.setSelectedValues(value.selectedValues);
          }
        });
        rootStore.gridStore.offset = 0;
        rootStore.gridStore.indexChanges = true;
        rootStore.resetAllActivefun();
      });
      return true;
    } catch (error) {
      console.error(error);
    } 
  };
  async handleCsvUpload(navigate, userId) {
    try {
      const csvFile = this.dynamicFlags.get("csvFile");
      if (!csvFile) {
        alert("Please select a CSV file first");
        return;
      }
      const formData = new FormData();
      formData.append("file", csvFile);
      formData.append("userId", userId);
      let importUniqueId = uuidv4();
      formData.append("importUniqueId", importUniqueId);
      runInAction(() => {
        this.dynamicFlags.set("importUniqueId", importUniqueId);
      });
      this.applyTheValue({ loadingUploadCSV: true });
      const response = await this.formDataAxios("/importCSV", "POST", formData);
      if (response) {
        this.applyTheValue({
          selectEnrichmentPopup: true,
          loadingUploadCSV: false,
        });
      }
      const newTableId = response?.data?.data?.tableId;
      if (newTableId) {
        runInAction(() => {
          this.dynamicFlags.set("popuptype", undefined);
          this.dynamicFlags.set("modalLoader", undefined);
          rootStore.dynamicFlags.set("csvFile", undefined);
        });
        navigate(`/workspace?tableId=${newTableId}&filter=${false}`);
      } else {
        throw new Error("No tableId received from server");
      }
    } catch (error) {
      runInAction(() => {
        this.dynamicFlags.set("modalLoader", undefined);
      });
      alert(`Upload failed: ${error.response?.data?.message || error.message}`);
    }
  }
  async handleShowSuggestion() {
    this.applyTheValue({ showSuggestions: !this.getShowSuggesstions });
  }
  async handleSuggesstionsCall() {
    try {
      this.callCommonLoader(true);
      const res = await commonAxios(
        "/suggestions",
        "POST",
        {},
        {
          userId: this.gridStore.userId,
          textSearch: this.commonRootStoreMap.get("serachPrompt"),
        }
      );
      runInAction(() => {
        this.applyTheValue({ suggestions: res?.data?.suggestions || [] });
      });
    } catch (error) {
      console.error(error);
      this.callCommonLoader(false);
    }
  }
  async handleAIprompCall() {
    try {
      this.callCommonLoader(true);
      const res = await commonAxios(
        "/generate",
        "POST",
        {},
        {
          userId: this.gridStore.userId,
          textSearch: this.commonRootStoreMap.get("serachPrompt"),
        }
      );
      this.clearAll();
      this.handleSuggesstionsCall();
      runInAction(() => {
        this.applyTheValue({ selectedSearchId: res?.data?.id });
        this.setserachPrompt("");
        this.gridStore.savedGenerate();
        this.callCommonLoader(false);
      });
    } catch (error) {
      this.callCommonLoader(false);
      showAlertToast({
        type: "error", // probably 'error' for a validation fail
        title: "Something Went Wrong",
        message: error.message,
      });
    }
  }
  async handleApply(prompt) {
    runInAction(() => {
      this.applyTheValue({ serachPrompt: prompt, showSuggestions: false });
    });
    this.applyTheValue({ showSuggestions: false });
    this.handleAIprompCall();
  }
  setaccessEmail = (key, toggle) => {
    const itemkey = key;
    const toggleStore = this.getToggleStore(itemkey);
    runInAction(() => {
      toggleStore.setValue({
        val: toggle,
        trigger: false,
      });
      this.generateCompanyApi({ triggerKey: false, helpMe: false });
    });
  };
  formalize = (count) => {
    if (count === null || count === undefined || count === "") {
      return "";
    }
    // Use Intl.NumberFormat for thousands separator
    return Number(count).toLocaleString();
  };
  formatCount = (count) => {
    if (count === null || count === undefined || count === "") {
      return "";
    }
    const units = [
      { value: 1e15, symbol: "Q" }, // Quadrillion
      { value: 1e12, symbol: "T" }, // Trillion
      { value: 1e9, symbol: "B" }, // Billion
      { value: 1e6, symbol: "M" }, // Million
      { value: 1e3, symbol: "K" }, // Thousand
    ];
    for (const unit of units) {
      if (count >= unit.value) {
        return (
          (count / unit.value).toFixed(1).replace(/\.0$/, "") + unit.symbol
        );
      }
    }
    return count.toString();
  };
  getUserCredits = async () => {
    try {
      const response = await commonAxios("/fetchUserCredit", "POST", {}, {});
      runInAction(() => {
        this.setGlobalUserCredits(response.data.credit);
        this.setglobalShowCredit(response?.data?.hide ?? false);
      });
    } catch (e) {
      console.error(e);
     }
  };
  getuserdetails = async () => {
    try {
      const response = await commonAxios("/getProfile", "GET", {}, {});
      runInAction(() => {
        this.setGlobalUserName(response.data.userName);
        this.setGlobalUserEmail(response.data.email);
        this.setUserRole = response.data.activeRole;
      });
      return response;
    } catch (error) { 
      console.error(error);
     }
  };

  updatePermission(key, valid) {
    const permission = this.globalPermissions.find((perm) => perm.key === key);
    if (permission) {
      permission.valid = valid;
    }
  }
  hasPermission(key) {
    if (!Array.isArray(this.globalPermissions)) return false;
    return (
      this.globalPermissions.find((perm) => perm.key === key)?.valid || false
    );
  }
  getUserPermissions = async () => {
    try {
      const response = await commonAxios(
        "/fetchNavBar",
        "POST",
        {},
        {
          type: "permissions",
        }
      );
      runInAction(() => {
        this.setGlobalUserPermissions(response.data);
      });
    } catch (e) {
      console.error(e);
     }
  };
  getCheckUser = async (email) => {
    try {
      const response = await commonAxios(
        "/checkUserStatus",
        "POST",
        {},
        {
          email: email,
        }
      );
      if (response?.data?.nextRoute) {
        window.location.href = response?.data?.nextRoute;
      }
    } catch (e) { 
      console.error(e);
    }
  };
  toggleDropdownSearch = (menuItem) => {
    this.isDropdownOpenSearch[menuItem] = !this.isDropdownOpenSearch[menuItem];
  };
  setGlobalUserName = (value) => {
    this.globalUserName = value;
  };
  setGlobalUserEmail = (value) => {
    this.globalUserEmail = value;
  };
  setGlobalUserCredits = (value) => {
    this.globalUserCredits = value;
  };
  setglobalShowCredit = (value) => {
    this.globalShowCredit = value;
  };
  setGlobalUserRole = (value) => {
    this.globalUserRole = value;
  };
  setGlobalUserPermissions = (value) => {
    this.globalPermissions = value;
  };
  setGlobalAllowedRoutes = (value) => {
    this.globalAllowedRoutes = value;
  };
  setIsDropdownOpenSearch = (jsonData) => {
    this.isDropdownOpenSearch = jsonData;
  };
  setMenuConfiguration = (jsonData) => {
    this.menuConfiguration = jsonData;
  };
  nlpSavedSearch = async (msg) => {
    console.log(msg, "Got in data for msg");
    const searchId = msg?.data?._id ?? "";
    // Call it directly after the runInAction block
    const response = await this.getSavedSearchData(searchId);
    console.log(response, "Got in response after nplsearch")
    if (response) {
      this.generateCompanyApi({
        triggerKey: "",
        helpMe: false,
        spacialFlag: false,
        spacialFlagforPeople: false,
      });
    }
  };

}
export const rootStore = new RootStore();
